import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { takeUntil, tap } from 'rxjs/operators';
import { merge, Observable, Subject } from 'rxjs';
import { MobileMenuService } from '../../../../shared/services/mobile-menu.service';
import { mobileMenu } from '../../../../../data/mobile-menu';
import { MobileMenuItem } from '../../../../shared/interfaces/mobile-menu-item';
import { CartService } from 'src/app/shared/services/cart.service';
import { UserService } from 'src/app/shared/services/user.service';
import { CountryInfo, OnlineProduct } from 'src/app/shared/interfaces/product';
import { CurrencyService } from 'src/app/shared/services/currency.service';
import { BlockHeaderGroup } from 'src/app/shared/interfaces/block-header-group';
import { ShopService } from 'src/app/shared/api/shop.service';
import { StoreService } from 'src/app/shared/services/store.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CultureService } from 'src/app/shared/culture/culture.service';
import { CultureSwitchTarget, rememberLanguage, switchTargets } from 'src/app/shared/culture/culture-switch.component';

interface ProductsCarouselGroup extends BlockHeaderGroup {
    products$: Observable<OnlineProduct[]>;
}

interface ProductsCarouselData {
    abort$: Subject<void>;
    loading: boolean;
    products: OnlineProduct[];
    groups: ProductsCarouselGroup[];
}



@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss']
})
export class MobileMenuComponent implements OnDestroy, OnInit {
    private destroy$: Subject<any> = new Subject();
    countryInfo:CountryInfo;
    featuredProducts: ProductsCarouselData;

    /// The language switch (Multilang_Culture_Spec.md 5.6): this page in each of the site's languages.
    languageTargets: CultureSwitchTarget[] = [];
    readonly languageCode: string;

    isOpen = false;
    links: MobileMenuItem[] = mobileMenu; 
    constructor(public mobilemenu: MobileMenuService, private culture:StoreService, public currencyService: CurrencyService,
        private userService:UserService, public shop:ShopService, @Inject(PLATFORM_ID) private platformId: any,
        private cultures:CultureService, router:Router) 
    { 
        this.languageCode = this.cultures.lang.toUpperCase();
        this.languageTargets = switchTargets(this.cultures, router.url);
        router.events.pipe(filter(e => e instanceof NavigationEnd), takeUntil(this.destroy$))
            .subscribe(() => this.languageTargets = switchTargets(this.cultures, router.url));

        // Not the guess made before Locale/me answers (Pending): the flag's place stays empty until the visitor's own.
        this.culture.onCountry.pipe(takeUntil(this.destroy$)).subscribe(res =>
        {
            if(res && res.CurrencyMultiplier > 0 && !res.Pending){
                this.countryInfo = res;
            }
        });
    }

    ngOnInit(): void 
    { 
        this.mobilemenu.isOpen$.pipe(takeUntil(this.destroy$)).subscribe(isOpen => this.isOpen = isOpen);
        // this.mobilemenu.getMobileMenu().subscribe(res => {
        //     this.links = res;
        // })

        this.featuredProducts = {
            abort$: new Subject<void>(),
            loading: false,
            products: [],
            groups: [
                {
                    name: '',
                    current: true,
                    products$: this.shop.getLatestProducts(),
                }
            ],
        };

        // Browser only. The menu is closed when a page arrives, so nothing in it is visible in
        // the server render - yet this one carousel put twenty-four product cards into every
        // page the server produced, more than the visible page itself on most routes.
        if (isPlatformBrowser(this.platformId)) {
            this.groupChange(this.featuredProducts, this.featuredProducts.groups[0]);
        }
    }

    groupChange(carousel: ProductsCarouselData, group: BlockHeaderGroup): void {
        carousel.loading = true;
        carousel.abort$.next();

        (group as ProductsCarouselGroup).products$.pipe(
            tap(() => carousel.loading = false),
            takeUntil(merge(this.destroy$, carousel.abort$)),
        ).subscribe(x =>{ carousel.products = x;});
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    /// The visitor picked a language: kept for their emails (the page they go to is the link's).
    chooseLanguage(code: string): void {
        rememberLanguage(document, code);
    }

    onItemClick(event: MobileMenuItem): void {
        if (event.type === 'link') {
            this.mobilemenu.close();
        }

        // if (event.data && event.data.language) {
        //     console.log(event.data.language); // change language
        // }
    }
}
